import api from '../library/axios';
import RSA from '../library/rsa-encrypt';

export default {
  getList(page, search, company_id, order_by) {
    return api({
      method: 'get',
      url: '/api/users',
      params: {
        page,
        search,
        company_id,
        order_by,
      },
    });
  },
  createUser({
    name,
    phone_number,
    email,
    password,
    is_pic = false,
    company_id,
  }) {
    return api({
      method: 'post',
      url: '/api/users',
      data: {
        name,
        phone_number,
        email,
        password: RSA.encrypt(password, 'base64'),
        is_pic,
        company_id,
      },
    });
  },
  update(user_id, {
    name,
    phone_number,
    email,
    is_pic,
    password,
  }) {
    return api({
      method: 'patch',
      url: `/api/users/${user_id}`,
      data: {
        name,
        phone_number,
        email,
        is_pic,
        password,
      },
    });
  },
  delete(user_id) {
    return api({
      method: 'delete',
      url: `/api/users/${user_id}`,
    });
  },
  resetTwoFa(user_id) {
    return api({
      method: 'post',
      url: `/api/users/reset-2fa/${user_id}`,
    });
  },
};
